import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VDialog,{attrs:{"max-width":"600px"},model:{value:(_vm.mostrar),callback:function ($$v) {_vm.mostrar=$$v},expression:"mostrar"}},[_c(VCard,[_c(VCardTitle,[_c('span',{staticClass:"headline"},[_vm._v("Subir Archivo")])]),_c(VCardText,[_c(VContainer,[_c(VRow,[_c(VCol,[_c(VFileInput,{attrs:{"id":"input_archivo","label":"Seleccione Archivo","accept":".jpg, .png","outlined":"","dense":""},model:{value:(_vm.archivo),callback:function ($$v) {_vm.archivo=$$v},expression:"archivo"}})],1),_c(VCol,[_c(VBtn,{attrs:{"color":"green darken-1"},on:{"click":_vm.subirArchivo}},[_c(VIcon,[_vm._v("publish")])],1)],1)],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }